import { CurrentUser } from 'customTypes'
import { UserEvents } from 'hooks/analytics'
import { transformIntoGoogleTagManagerUser } from 'utils/analytics'
import { useGoogleTagManagerTrack } from './useGoogleTagManagerTrack'

export const useGoogleTagManagerIdentifyUser = () => {
  const track = useGoogleTagManagerTrack()

  const identify = async (user: Partial<NonNullable<CurrentUser>>) => {
    if (!user.email) throw new Error('We cannot identify user without email')

    track(UserEvents.Identify, await transformIntoGoogleTagManagerUser(user))
  }

  return identify
}
